import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import FYIClientDto from './FYIClientDto'

export namespace FYIDto {
   export const accessTokenSchema = z.object({
      accessId: z.string({ errorMap }).min(1),
      accessSecret: z.string({ errorMap }).min(1),
   })
   export type accessToken = z.output<typeof FYIDto.accessTokenSchema>

   export type clientMinimal = Pick<FYIClientDto, 'id' | 'name'> & { uuid: FYIClientDto['details']['uuid'] }

   export const clientsPerPage = 500

   export const getClientsInputSchema = z.object({
      page: z.number({ errorMap }).int().min(1),
      xeroId: z.string({ errorMap }).trim().min(1).optional(),
   })
   export type getClientsInput = z.output<typeof getClientsInputSchema>

   export interface clientsPage {
      clients: clientMinimal[]
      matchedClient: clientMinimal | null
      page: number
      totalPages: number
   }
}
